import React, { useState, useEffect } from 'react';
import { Anchor } from 'antd';
import { useSwitch } from '../../pages/SwitchContext';
import { optimizedHandleScroll } from '../../utils/scroll';
import { RxCross2 } from 'react-icons/rx';
import useScreenSize1 from '../../hooks/useScreenSize1';

const { Link } = Anchor;

/**
 * Sidebar-Navigation für Gutachten-Formulare.
 * @param {{ href: string, title: string }[]} links - Anchor-Links
 */
const GutachtenMenuContainer = ({ onClose, links }) => {
    const { isSwitchOn } = useSwitch();
    const [isInLower20, setIsInLower20] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', optimizedHandleScroll);
        return () => window.removeEventListener('scroll', optimizedHandleScroll);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const isDeviceHeightBelow650 = window.innerHeight < 650;
            const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;
            setIsInLower20(isDeviceHeightBelow650 && scrollPercentage >= 80);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={`sidebar rounded-r-[30px] ${isSwitchOn ? 'bg-black' : 'bg-white'}`}>
            <div className="ml-[197px]">
                <RxCross2
                    onClick={onClose}
                    className={`xl:hidden ${isSwitchOn ? 'text-white' : 'text-black'} text-[30px] mb-[20px]`}
                />
            </div>
            <Anchor affix={false} offsetTop={80} className={`your-component ${isInLower20 ? 'lower-20' : ''}`}>
                {links.map(({ href, title }) => (
                    <Link
                        key={href}
                        className={`${isSwitchOn ? 'textwhite' : 'textdark'}`}
                        href={href}
                        title={title}
                    />
                ))}
            </Anchor>
        </div>
    );
};

/**
 * Äußere Hülle für alle einfachen Gutachten-Formular-Tabs.
 * Kapselt Sidebar-Toggle, responsives Layout und Darkmode.
 * @param {{ href: string, title: string }[]} menuLinks
 * @param {React.ReactNode} children - FormContainer der jeweiligen Komponente
 */
const GutachtenShell = ({ menuLinks, children }) => {
    const [vis, setVis] = useState(false);
    const { isDesktopView } = useScreenSize1();
    const { isSwitchOn } = useSwitch();

    useEffect(() => {
        setVis(isDesktopView);
    }, [isDesktopView]);

    return (
        <div className="w-full">
            <div
                className={`${!isDesktopView ? 'visible cursor-pointer' : 'hidden'} text-white pl-[15px]`}
                onClick={() => setVis(!vis)}
            >
                <button className="menuBtn">Menu</button>
            </div>
            <div
                className={`flex flex-row gap-[30px] relative mr-[15px] mb-[40px] ${!isDesktopView ? 'ml-[15px]' : ''}`}
            >
                {vis && (
                    <div className="w-[299px] absolute xl:relative z-10 h-full xl:h-auto">
                        <GutachtenMenuContainer
                            onClose={() => setVis(false)}
                            links={menuLinks}
                        />
                    </div>
                )}
                <div className={`w-full ${isSwitchOn ? 'bg-black' : 'bg-white'} rounded-[30px]`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default GutachtenShell;
